module.exports = __webpack_public_path__ + "img/venue-2.de491181.png";